import { lazy } from "react";
import { createBrowserRouter, Navigate } from "react-router-dom";
import { AuthPage } from "./pages/AuthPage";
import { AdminPortalGuard, StaffPortalGuard } from "./portal-guards";

const AdminDashboardPage = lazy(() =>
  import("./pages/admin/AdminPages").then((m) => ({ default: m.AdminDashboardPage })),
);
const AdminTasksPage = lazy(() => import("./pages/admin/AdminPages").then((m) => ({ default: m.AdminTasksPage })));
const AdminWorkLogsPage = lazy(() =>
  import("./pages/admin/AdminPages").then((m) => ({ default: m.AdminWorkLogsPage })),
);
const AdminStaffPage = lazy(() => import("./pages/admin/AdminPages").then((m) => ({ default: m.AdminStaffPage })));
const AdminStatusPage = lazy(() => import("./pages/admin/AdminPages").then((m) => ({ default: m.AdminStatusPage })));
const AdminAlertsPage = lazy(() =>
  import("./pages/admin/AdminAlertsPage").then((m) => ({ default: m.AdminAlertsPage })),
);
const AdminRoleKpiLibraryPage = lazy(() =>
  import("./pages/admin/AdminRoleKpiLibraryPage").then((m) => ({ default: m.AdminRoleKpiLibraryPage })),
);
const AdminKpisPage = lazy(() => import("./pages/admin/KpiPages").then((m) => ({ default: m.AdminKpisPage })));
const AdminAnalyticsPage = lazy(() =>
  import("./pages/admin/AdminAnalyticsPage").then((m) => ({ default: m.AdminAnalyticsPage })),
);
const AdminStaffDetailPage = lazy(() =>
  import("./pages/admin/AdminStaffDetailPage").then((m) => ({ default: m.AdminStaffDetailPage })),
);
const TaskDetailPage = lazy(() =>
  import("./pages/TaskDetailPage").then((m) => ({ default: m.TaskDetailPage })),
);
const StaffDashboardPage = lazy(() =>
  import("./pages/staff/StaffPages").then((m) => ({ default: m.StaffDashboardPage })),
);
const StaffTasksPage = lazy(() => import("./pages/staff/StaffPages").then((m) => ({ default: m.StaffTasksPage })));
const StaffWorkLogPage = lazy(() =>
  import("./pages/staff/StaffPages").then((m) => ({ default: m.StaffWorkLogPage })),
);
const StaffAlertsPage = lazy(() =>
  import("./pages/staff/StaffAlertsPage").then((m) => ({ default: m.StaffAlertsPage })),
);
const StaffKpisPage = lazy(() => import("./pages/staff/StaffKpisPage").then((m) => ({ default: m.StaffKpisPage })));
const StaffAccountabilityPage = lazy(() =>
  import("./pages/staff/StaffAccountabilityPage").then((m) => ({ default: m.StaffAccountabilityPage })),
);
const StaffMyKpiLibraryPage = lazy(() =>
  import("./pages/staff/StaffMyKpiLibraryPage").then((m) => ({ default: m.StaffMyKpiLibraryPage })),
);

function AdminTaskDetailRoute() {
  return <TaskDetailPage variant="admin" />;
}

function StaffTaskDetailRoute() {
  return <TaskDetailPage variant="staff" />;
}

export const appRouter = createBrowserRouter(
  [
    { path: "/", element: <AuthPage /> },
    { path: "/login", element: <Navigate to="/" replace /> },
    { path: "/admin/login", element: <Navigate to="/" replace /> },
    { path: "/staff/login", element: <Navigate to="/" replace /> },
    {
      path: "/admin",
      element: <AdminPortalGuard />,
      children: [
        { index: true, element: <Navigate to="dashboard" replace /> },
        { path: "dashboard", element: <AdminDashboardPage /> },
        { path: "analytics", element: <AdminAnalyticsPage /> },
        { path: "kpis", element: <AdminKpisPage /> },
        { path: "role-kpi-library", element: <AdminRoleKpiLibraryPage /> },
        { path: "status", element: <AdminStatusPage /> },
        { path: "tasks", element: <AdminTasksPage /> },
        { path: "tasks/:id", element: <AdminTaskDetailRoute /> },
        { path: "work-logs", element: <AdminWorkLogsPage /> },
        { path: "staff", element: <AdminStaffPage /> },
        { path: "staff/:id", element: <AdminStaffDetailPage /> },
        { path: "alerts", element: <AdminAlertsPage /> },
      ],
    },
    {
      path: "/staff",
      element: <StaffPortalGuard />,
      children: [
        { index: true, element: <Navigate to="dashboard" replace /> },
        { path: "dashboard", element: <StaffDashboardPage /> },
        { path: "kpis", element: <StaffKpisPage /> },
        { path: "my-kpi-library", element: <StaffMyKpiLibraryPage /> },
        { path: "tasks", element: <StaffTasksPage /> },
        { path: "tasks/:id", element: <StaffTaskDetailRoute /> },
        { path: "work-log", element: <StaffWorkLogPage /> },
        { path: "accountability", element: <StaffAccountabilityPage /> },
        { path: "alerts", element: <StaffAlertsPage /> },
      ],
    },
  ],
);
